import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const sphere = geo.createNode('sphere');
	sphere.p.center.x.set(-2);
	const box = geo.createNode('box');
	box.p.center.x.set(2);
	const torus = geo.createNode('torus');
	torus.p.center.z.set(-2);
	const torusKnot = geo.createNode('torusKnot');
	torusKnot.p.center.z.set(2);

	// merge the geometries
	const merge = geo.createNode('merge');
	merge.setInput(0, sphere);
	merge.setInput(1, box);
	merge.setInput(2, torus);
	merge.setInput(3, torusKnot);

	// create the material
	const materials = root.createNode('materialsNetwork');
	const meshBasic = materials.createNode('meshBasic');
	meshBasic.p.color.set([0, 0.5, 1]);

	// assign the material
	const material = geo.createNode('material');
	material.setInput(0, merge);
	material.p.material.setNode(meshBasic);
	// set the display flag on the material node
	material.flags.display.set(true);

	// no need to add a light for meshBasic material
	// scene.root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [sphere],
		autoLayout: true,
	};
}
// export const matMeshBasic = [new Example({name: `${ExamplePrefix.BY_NODE}/mat/meshBasic`, createData})];
